module.exports = __webpack_public_path__ + "static/media/sleep-brochure.eeec04f0.pdf";